import React, { useEffect, useState, Component } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { ArrowLeft } from 'lucide-react';
function LottieAnimation() {
  const [animData, setAnimData] = useState<object | null>(null);
  const [LottieComp, setLottieComp] = useState<ComponentType<any> | null>(null);
  useEffect(() => {
    // Dynamically import lottie-react
    import('lottie-react').then(mod => {
      setLottieComp(() => mod.default);
    }).catch(() => {
      // If lottie-react not available, silently fail
    });
    // Fetch a 404 animation from LottieFiles
    fetch('https://assets2.lottiefiles.com/packages/lf20_kcsr6fcp.json').then(res => res.json()).then(data => setAnimData(data)).catch(() => {});
  }, []);
  if (!LottieComp || !animData) {
    // Fallback: simple animated 404 text
    return <div className="flex items-center justify-center h-full" data-id="element-1312">
        <motion.span className="text-8xl font-heading font-bold text-white/20" animate={{
        scale: [1, 1.05, 1],
        opacity: [0.2, 0.3, 0.2]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-1313">
          404
        </motion.span>
      </div>;
  }
  return <LottieComp animationData={animData} loop autoPlay style={{
    width: '100%',
    height: '100%'
  }} data-id="element-1314" />;
}
export function NotFoundPage() {
  const navigate = useNavigate();
  return <main className="min-h-screen bg-[#00316B] flex flex-col items-center justify-center relative overflow-hidden px-4" data-id="element-1315">
      {/* Massive Watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden" data-id="element-1316">
        <span className="font-heading font-bold text-white opacity-[0.03] leading-none" style={{
        fontSize: '30vw'
      }} data-id="element-1317">
          404
        </span>
      </div>

      <div className="relative z-10 text-center max-w-2xl mx-auto w-full" data-id="element-1318">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6
      }} className="w-full max-w-[400px] h-[300px] mx-auto mb-8" data-id="element-1319">
          <LottieAnimation data-id="element-1320" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-[#FF6600] font-bold tracking-widest uppercase text-sm mb-4" data-id="element-1321">
          Error 404
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-4xl md:text-6xl font-bold font-heading text-white mb-6" data-id="element-1322">
          Ooops! I think we are lost.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="text-white/70 text-lg md:text-xl leading-relaxed mb-10 max-w-lg mx-auto" data-id="element-1323">
          Let's get you back somewhere familiar.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="flex justify-center" data-id="element-1324">
          <Button className="bg-[#FF6600] text-white hover:bg-[#CC5200] border-none" size="lg" leftIcon={<ArrowLeft className="w-5 h-5" data-id="element-1326" />} onClick={() => navigate('/')} data-id="element-1325">
            Back to Home
          </Button>
        </motion.div>
      </div>
    </main>;
}